import { type BoxProps } from '@pets-ui/Box/Box'
import { Box } from '@pets-ui/Box/Box'
import { type TextProps } from '@pets-ui/Text/Text'
import { Text } from '@pets-ui/Text/Text'

export interface DrawerHeaderProps extends BoxProps {
  align?: TextProps['align']
}

export const DrawerHeader = (props: DrawerHeaderProps) => {
  const { align, children, ...rest } = props
  return (
    <Box p="12px 16px" {...rest}>
      <Text variant="subtitle" align={align}>
        {children}
      </Text>
    </Box>
  )
}
